import { render, staticRenderFns } from "./RatingField.vue?vue&type=template&id=0a8ee9dc&"
import script from "./RatingField.vue?vue&type=script&lang=js&"
export * from "./RatingField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseField: require('/app/components/fields/BaseField.vue').default})
